// src/pages/DiscountsPage.js
import React, { useEffect, useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase/firestore';
import ProductCard from '../Components/ProductCard';

const DiscountsPage = () => {
  const [discountedProducts, setDiscountedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDiscountedProducts = async () => {
      try {
        const q = query(
          collection(db, 'products'),
          where('discount', '>', 0)
        );
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setDiscountedProducts(data);
      } catch (err) {
        console.error('Error loading discounted products:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchDiscountedProducts();
  }, []);

  // Telegram back button
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (!tg) return;

    tg.BackButton.show();
    const handleBack = () => navigate(-1);

    tg.BackButton.onClick(handleBack);

    return () => {
      tg.BackButton.hide();
      tg.BackButton.offClick(handleBack);
    };
  }, [navigate]);

  return (
    <div className="p-4 max-w-5xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">Discounts Section</h1>
      {loading ? (
        <p>Loading...</p>
      ) : discountedProducts.length === 0 ? (
        <p>No discounted products available.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {discountedProducts.map((product) => (
            <ProductCard 
              key={product.id} 
              product={{ ...product, price: `${product.price}€` }} 
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default DiscountsPage;
